import React from 'react';

export default function Button({ 
  children, 
  onClick, 
  type = 'button', 
  variant = 'contained', 
  color = 'primary',
  size = 'medium',
  disabled = false,
  className = '',
  icon = null,
  ...props 
}) {
  const baseClasses = 'rounded-sm transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const sizeClasses = {
    xs: "px-1.5 py-0.5 text-[10px]",
    vsmall: "px-2 py-0.5 text-[10px]",
    small: "px-2.5 py-1 text-xs font-semibold",
    medium: "px-3 py-1.5 text-sm",
    large: "px-4 py-2 text-base",
};

  const variantClasses = {
    contained: {
      primary: 'bg-primary-500 hover:bg-primary-600 text-white focus:ring-primary-600 shadow-sm',
      secondary: 'bg-gray-700 hover:bg-gray-600 text-white focus:ring-gray-500 shadow-sm',
      error: 'bg-red-600 hover:bg-red-700 text-white focus:ring-red-500 shadow-sm',
      success: 'bg-green-600 hover:bg-green-700 text-white focus:ring-green-500 shadow-sm',
      transparent:'text-primary-500 bg-transparent hover:bg-gray-200 focus:ring-transparent',
    },
    outlined: {
      primary: 'border border-primary-700 text-primary-700 hover:bg-primary-50 focus:ring-primary-500',
      secondary: 'border border-gray-600 text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
      error: 'border border-red-600 text-red-600 hover:bg-red-50 focus:ring-red-500',
      success: 'border border-green-600 text-green-600 hover:bg-green-50 focus:ring-green-500',
      transparent:'border border-transparent text-hshop-500 hover:bg-transparent  focus:ring-transparent shadow-sm',
    },
    text: {
      primary: 'text-primary-700 hover:bg-primary-50 focus:ring-primary-500',
      secondary: 'text-gray-700 hover:bg-gray-50 focus:ring-gray-500',
      error: 'text-red-600 hover:bg-red-50 focus:ring-red-500',
      success: 'text-green-600 hover:bg-green-50 focus:ring-green-500',
     transparent:'text-hshop-500 hover:bg-transparent  focus:ring-transparent',
    },
  };

  const disabledClasses = 'opacity-50 cursor-not-allowed pointer-events-none';

  const classes = `
    ${baseClasses}
    ${sizeClasses[size]}
    ${variantClasses[variant][color] || variantClasses[variant].primary}
    ${disabled ? disabledClasses : ''}
    ${className}
  `.trim().replace(/\s+/g, ' ');

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${classes} ${icon ? 'flex items-center gap-0' : ''}`}
      {...props}
    >

      {icon && <span className="mr-2">{icon}</span>}
      {children}
    </button>
  );
}
